import Phaser from 'phaser';
import { Save } from '../save.js';
import { formatTime } from '../utils.js';

export class GameOverScene extends Phaser.Scene {
  constructor() { super('GameOver'); }

  init(data) { this.runData = data; }

  create() {
    const W = this.scale.width, H = this.scale.height;
    this.add.rectangle(0, 0, W, H, 0x05050a, 1).setOrigin(0, 0);

    this.add.text(W / 2, 90, 'RUN COMPLETE', {
      fontFamily: 'Courier New, monospace', fontSize: '28px', color: '#ff7799',
    }).setOrigin(0.5);

    const d = this.runData || {};
    const lines = [
      'time survived:  ' + formatTime(d.time || 0),
      'enemies slain:  ' + (d.kills || 0),
      'final level:    ' + (d.level || 1),
      '',
      'credits earned: ' + (d.earnedCredits || 0) + 'c',
    ];
    this.add.text(W / 2, 180, lines.join('\n'), {
      fontFamily: 'Courier New, monospace', fontSize: '16px', color: '#e8e8ff',
      align: 'center', lineSpacing: 4,
    }).setOrigin(0.5, 0);

    const save = Save.load();
    this.add.text(W / 2, 340, 'bank: ' + save.credits + 'c', {
      fontFamily: 'Courier New, monospace', fontSize: '18px', color: '#ffd755',
    }).setOrigin(0.5);

    this._mkButton(W / 2, 430, 'RETRY', () => this.scene.start('Game'));
    this._mkButton(W / 2, 480, 'UPGRADES', () => this.scene.start('Shop'));
    this._mkButton(W / 2, 530, 'MAIN MENU', () => this.scene.start('Menu'));

    this.input.keyboard.once('keydown-ENTER', () => this.scene.start('Game'));
    this.input.keyboard.once('keydown-SPACE', () => this.scene.start('Game'));
  }

  _mkButton(x, y, label, cb) {
    const t = this.add.text(x, y, label, {
      fontFamily: 'Courier New, monospace', fontSize: '18px',
      color: '#e8e8ff', backgroundColor: '#1a1430', padding: { x: 14, y: 7 },
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });
    t.on('pointerover', () => t.setStyle({ color: '#fff7ff', backgroundColor: '#3a256a' }));
    t.on('pointerout',  () => t.setStyle({ color: '#e8e8ff', backgroundColor: '#1a1430' }));
    t.on('pointerdown', cb);
    return t;
  }
}
